import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=194be90c&scoped=true&"
import script from "./TeamMemberCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamMemberCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamMemberCard.vue?vue&type=style&index=0&id=194be90c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194be90c",
  null
  
)

export default component.exports